import {
  Component,
  PLATFORM_ID,
  computed,
  effect,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';

import { StyleService } from 'src/app/services/style.service';
import { InnerHtmlComponent } from '../inner-html/inner-html.component';
import { RouterLink } from '@angular/router';
import { Layout } from 'src/app/models/layout/layout.model';
import { Footer } from 'src/app/models/layout/footer.model';
import { LayoutService } from 'src/app/services/layout.service';
import { CookieConsentService } from 'src/app/services/cookie-consent.service';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-footer',
  imports: [InnerHtmlComponent, RouterLink],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  styleService = inject(StyleService);
  layoutService = inject(LayoutService);
  settingsService = inject(SettingsService);
  platformId = inject(PLATFORM_ID);
  layout?: Layout;
  footer: Footer = new Footer();
  calculatedStyles?: string;
  parentStyles?: string;
  copyrightStyles?: string;

  iconColor = '#fff';

  cookieSettingsShow = computed(() => this.cookieConsentService.showConsent());
  cookieConsentService = inject(CookieConsentService);

  constructor() {
    effect(() => {
      this.footer = this.layoutService.layout()?.Footer ?? new Footer();

      if (this.footer.Columns && this.footer.Columns.length > 0) {
        this.footer.Columns.forEach((column) => {
          if (column.Links && column.Links.length > 0) {
            column.Links.forEach((link) => {
              if (
                link.Url.substring(0, 4) === 'http' ||
                link.Url.substring(0, 7) === 'mailto:'
              ) {
                link.ExternalLink = true;
              } else if (link.Url.substring(0, 1) !== '/') {
                link.Url = '/' + link.Url;
              }
            });
          }
        });
      }

      this.style();

      this.iconColor =
        this.settingsService.setting()?.Privacy?.CookieIconColor ?? '#fff';
    });
  }

  style() {
    let parentOutput: string[] = [];
    let output: string[] = [];

    const styles = this.footer;

    if (!styles) {
      return;
    }

    if (styles.ColumnGap) output.push(`gap: ${styles.ColumnGap}`);

    this.parentStyles = parentOutput.join(';');
    this.calculatedStyles = output.join(';');

    if (this.footer.TemplateColumns) {
      output.push(`grid-template-columns: ${this.footer.TemplateColumns}`);
    } else {
      if (this.footer?.Columns && this.footer.Columns.length > 0) {
        output.push(
          `grid-template-columns: repeat(${this.footer.Columns.length}, 1fr)`,
        );
      } else {
        output.push(`grid-template-columns: 1fr`);
      }
    }

    this.parentStyles = parentOutput.join(';');
    this.calculatedStyles = output.join(';');
  }

  openCookieSettings() {
    this.cookieConsentService.showConsent.set(true);
  }
}
